import { useMutation } from '@tanstack/react-query'

import { createBankTransfers } from '@src/api'
import { DefaultApiCreateBankTransfersRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useCreateBankTransfers = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiCreateBankTransfersRequest) =>
      createBankTransfers(axiosInstance, params),
  })
}
